import { Component, OnInit } from "@angular/core";
import {
  NivelAcademicosDataModel,
  NivelAcademicosModel,
} from "../../../core/domain/nivelAcademico.model";
import { SimuladorPrimaryInterface } from "../../../core/ports/primary/simulador.primary.interface";
import { InstitucionesDataModel } from "../../../core/domain/instituciones.model";
import {
  CampusDataModel,
  CampusModel,
} from "../../../core/domain/campus.model";
import {
  PeriodosDataModel,
  PeriodosModel,
} from "../../../core/domain/periodos.model";
import {
  ProgramasDataModel,
  ProgramasModel,
} from "../../../core/domain/programas.model";
import { FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { AreaDataModel, AreaModel } from "../../../core/domain/area.model";
import { CalcularRequestModel } from "../../../core/domain/params/requestCalcularRequest.model";
import { CalcularModel } from "../../../core/domain/calcular.model";
import { EmmiterService } from "../../../../../services/emmiter/emmiter.service";
import { BecaDataModel, BecaModel } from "../../../core/domain/beca.model";
import {
  PrestamosDataModel,
  PrestamosModel,
} from "../../../core/domain/prestamos.model";
import {
  ApoyosDataModel,
  ApoyosModel,
} from "../../../core/domain/apoyos.model";
import { MensajesService } from "../../../../../../../src/app/services/mensajes/mensajes.service";
import { IdentificadorMensajesEnum } from "../../../../../../../src/app/enum/mensajes.enum";
import { SafeHtml } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { SimuladorService } from "../../secondary/apirest/simulador.service";
import { MontoMaximo } from "../../../core/interfaces/monto-maximo";

@Component({
  selector: "app-nivel-academico",
  templateUrl: "./nivel-academico.component.html",
  styleUrl: "./nivel-academico.component.css",
})
export class NivelAcademicoComponent implements OnInit {
  categories: any[] = [
    { name: "Si", key: "S", value: true },
    { name: "No", key: "N", value: false },
  ];

  institucionOption: string = "TMTY";
  dataInstituciones: InstitucionesDataModel[] = [];
  dataNivelAcademico: NivelAcademicosDataModel[] = [];
  dataCampus: CampusDataModel[] = [];
  dataPeriodos: PeriodosDataModel[] = [];
  dataAreas: AreaDataModel[] = [];
  dataProgramas: ProgramasDataModel[] = [];
  limiteSuperior: number = 0;
  nivelAcademicoData: NivelAcademicosDataModel[] | undefined;
  selectedNivelAcademico: NivelAcademicosDataModel | undefined;
  hasErrorLimiteSuperior: boolean = false;
  formColegiatura: FormGroup = new FormGroup({});
  dataBeca: BecaDataModel[] = [];
  dataPrestamos: PrestamosDataModel[] = [];
  dataApoyos: ApoyosDataModel[] = [];
  textoSeguro: SafeHtml = "";
  textoApoyos: SafeHtml = "";
  claveNivelAcademico: string = "03";
  paceholder = environment.paceholder;
  emptyPaceholder: string = environment.emptyPaceholder;
  defaultEmptyPaceholder: string = "Selecciona primero las opciones anteriores";
  firstEmptyPaceholder: any = {
    niveles: {
      value: this.emptyPaceholder,
    },
    periodo: {
      value: this.defaultEmptyPaceholder,
    },
    campus: {
      value: this.defaultEmptyPaceholder,
    },
    area: {
      value: this.defaultEmptyPaceholder,
    },
    programa: {
      value: this.defaultEmptyPaceholder,
    },
    beca: {
      value: this.defaultEmptyPaceholder,
    },
    prestamo: {
      value: this.defaultEmptyPaceholder,
    },
    apoyos: {
      value: this.defaultEmptyPaceholder,
    },
  };

  constructor(
    private usecase: SimuladorPrimaryInterface,
    private fb: UntypedFormBuilder,
    private emmiter: EmmiterService,
    private mensajesService: MensajesService,
    private simuladorService: SimuladorService
  ) {
    this.initForm();
  }

  initForm() {
    this.formColegiatura = this.fb.group({
      nivelAcademico: ["", [Validators.required]],
      periodo: ["", [Validators.required]],
      campus: ["", [Validators.required]],
      area: ["", [Validators.required]],
      programa: ["", [Validators.required]],
      gastosMedicosMayores: [true, []],
      beca: [null, []],
      apoyos: [true, []],
      prestamos: [null, []],
    });
  }

  ngOnInit() {
    this.getMessages();
    this.getNivelAcademico();
    this.getReiniciarEmmiter();
    this.nivelAcademicoSelected();
    this.periodoSelected();
    this.campusSelected();
    this.areaSelected();
    this.gastosMedicosMayoresSelected();
  }

  getMessages() {
    this.mensajesService.labelTextEmmiter.subscribe((response: boolean) => {
      if (response) {
        this.textoSeguro =
          this.mensajesService.getMensajeByEtiquetaBypassSecurityTrustHtml(
            IdentificadorMensajesEnum.seguros
          );
        this.textoApoyos =
          this.mensajesService.getMensajeByEtiquetaBypassSecurityTrustHtml(
            IdentificadorMensajesEnum.apoyos
          );
      }
    });
  }

  nivelAcademicoSelected() {
    this.nivelAcademico?.valueChanges.subscribe(
      (data: NivelAcademicosDataModel) => {
        if (data) {
          this.dataAreas = [];
          this.dataProgramas = [];
          this.dataCampus = [];
          this.dataBeca = [];
          this.dataPrestamos = [];
          if (this.isNivelValidator(data.clave)) {
            this.area.setValidators([]);
          } else {
            this.area.setValidators([Validators.required]);
            this.area.setValue("");
          }
          this.getPeriodos();
          this.getApoyo();
          this.campus.setValue("");
          this.beca.setValue(null);
          this.prestamos.setValue(null);
          this.gastosMedicosMayores.setValue(true);
          this.apoyos.setValue("");
          this.periodo.setValue("");
          this.programa.setValue("");
          this.calcular();
          this.hasErrorLimiteSuperior = false;
        }
      }
    );
  }

  isNivelValidator(clave: string): boolean {
    return clave === this.claveNivelAcademico;
  }

  isNivelAndCampusSelected() {
    if (this.nivelAcademico.valid && this.campus.valid && this.periodo.valid) {
      this.getAreas();
    }
  }

  campusSelected() {
    this.campus?.valueChanges.subscribe((data: CampusDataModel) => {
      if (data) {
        this.getApoyo();
        this.isNivelAndCampusSelected();
        this.area.setValue("");
        this.gastosMedicosMayores.setValue(true);
        this.apoyos.setValue("");
        this.programa.setValue("");
        //this.calcular();
        this.validarPorcentajeMaximo();
      }
    });
  }

  areaSelected() {
    this.area?.valueChanges.subscribe((data: AreaDataModel) => {
      if (data) {
        if (this.nivelAcademico.valid && this.campus.valid && this.area.valid) {
          this.getProgramas();
          this.programa.setValue("");
          this.gastosMedicosMayores.setValue(true);
          //this.calcular();
          this.validarPorcentajeMaximo();
        }
      }
    });
  }

  periodoSelected() {
    this.periodo?.valueChanges.subscribe((data: PeriodosDataModel) => {
      if (data) {
        this.getPrestamos();
        this.getBeca();
        this.campus.setValue("");
        this.beca.setValue(null);
        this.prestamos.setValue(null);
        this.gastosMedicosMayores.setValue(true);
        this.area.setValue("");
        this.programa.setValue("");
        this.isNivelAndCampusSelected();
        this.getApoyo();
        this.getCampus();
        this.apoyos.setValue("");
        //this.calcular();
        this.validarPorcentajeMaximo();
      }
    });
  }

  getReiniciarEmmiter() {
    this.emmiter.reiniciarEmmiter.subscribe(() => {
      this.formColegiatura.reset();
      this.dataCampus = [];
      this.dataPeriodos = [];
      this.dataAreas = [];
      this.dataProgramas = [];
      this.gastosMedicosMayores.setValue(true);
      this.hasErrorLimiteSuperior = false;
    });
  }

  gastosMedicosMayoresSelected() {
    this.gastosMedicosMayores?.valueChanges.subscribe((data: boolean) => {
      if (!data) this.apoyos.setValue("");
      else this.setApoyos();
      //this.calcular();
      this.validarPorcentajeMaximo();
    });
  }

  getNivelAcademico() {
    this.usecase
      .getNivelAcademico(this.institucionOption)
      .subscribe((response: NivelAcademicosModel) => {
        this.dataNivelAcademico = response.data?.attributes;
      });
  }

  getCampus() {
    this.usecase
      .getCampus({
        institucion: this.institucionOption,
        nivel: this.nivelAcademico?.value?.clave,
        periodo: `${this.periodo?.value?.term}`,
      })
      .subscribe((response: CampusModel) => {
        if (!response) {
          this.firstEmptyPaceholder.campus.value = this.emptyPaceholder;
        }
        this.dataCampus = response.data?.attributes;
      });
  }

  getPeriodos() {
    this.usecase
      .getPeriodos({
        institucion: this.institucionOption,
        nivel: this.nivelAcademico?.value?.clave,
      })
      .subscribe((response: PeriodosModel) => {
        if (!response) {
          this.firstEmptyPaceholder.periodo.value = this.emptyPaceholder;
        }
        this.dataPeriodos = response.data?.attributes;
      });
  }

  getProgramas() {
    this.usecase
      .getProgramas({
        campus: this.campus?.value.clave,
        area: this.area?.value.id,
        nivel: this.nivelAcademico?.value?.clave,
        periodo: `${this.periodo?.value?.term}`,
      })
      .subscribe((response: ProgramasModel) => {
        if (!response) {
          this.firstEmptyPaceholder.programa.value = this.emptyPaceholder;
        }
        this.dataProgramas = response.data?.attributes;
      });
  }

  getAreas() {
    this.usecase
      .getAreas({
        campus: this.campus?.value.clave,
        institucion: this.institucionOption,
        nivel: this.nivelAcademico?.value?.clave,
      })
      .subscribe((response: AreaModel) => {
        if (!response) {
          this.firstEmptyPaceholder.area.value = this.emptyPaceholder;
        }
        this.dataAreas = response.data?.attributes;
        if (this.isNivelValidator(this.nivelAcademico?.value?.clave)) {
          this.area.setValue(this.dataAreas[0]);
          this.getProgramas();
        }
      });
  }

  getBeca() {
    this.usecase
      .getBeca(this.institucionOption, this.nivelAcademico?.value?.clave, this.periodo?.value?.term)
      .subscribe((response: BecaModel) => {
        if (!response) {
          this.firstEmptyPaceholder.beca.value = this.emptyPaceholder;
        }
        this.dataBeca = response.data?.attributes;
      });
  }

  getApoyo() {
    if (
      this.campus?.invalid ||
      this.nivelAcademico?.invalid ||
      this.periodo?.invalid
    )
      return;

    this.usecase
      .getApoyos({
        campus: this.campus?.value?.clave,
        institucion: this.institucionOption,
        nivel: this.nivelAcademico?.value?.clave,
        periodo: this.periodo?.value?.term.toString(),
      })
      .subscribe((response: ApoyosModel) => {
        if (!response) {
          this.firstEmptyPaceholder.apoyos.value = this.emptyPaceholder;
        }

        this.dataApoyos = response.data?.attributes;
        this.setApoyos();
      });
  }

  setApoyos() {
    this.apoyos.setValue(
      this.dataApoyos.filter((data) => data.clave === "SGMM")[0]
    );
  }

  getPrestamos() {
    this.usecase
      .getPrestamos(this.institucionOption, this.nivelAcademico?.value?.clave, this.periodo?.value?.term)
      .subscribe((response: PrestamosModel) => {
        if (!response) {
          this.firstEmptyPaceholder.prestamo.value = this.emptyPaceholder;
        }
        this.dataPrestamos = response.data?.attributes;
      });
  }

  calcular() {
    this.formColegiatura.markAllAsTouched();
    if (this.formColegiatura.invalid) {
      this.emmiter.resumenEmmiter.emit(null);
      this.emmiter.borrarFormulario.emit();
      return;
    }

    const body: CalcularRequestModel = {
      data: {
        campus: this.campus?.value?.clave,
        nivel: this.nivelAcademico?.value?.clave,
        periodo: `${this.periodo?.value?.term}`,
        programa: this.programa?.value?.id,
        area: this.isNivelValidator(this.nivelAcademico?.value?.clave)
          ? this.dataAreas[0].id
          : this.area?.value?.id,
        institucion: this.institucionOption,
        beca: this.beca?.value?.porcentaje,
        prestamo: this.prestamos?.value?.porcentaje,
        apoyo: this.apoyos?.value?.clave,
      },
    };
    this.useCaseCalcular(body);
  }

  validarPorcentajeMaximo(): void {

    this.simuladorService.getLimitesBecasPrestamos(this.institucionOption, this.nivelAcademico?.value?.clave, this.periodo?.value?.term).subscribe({
      next: (response: MontoMaximo) => {
        this.limiteSuperior = response.data.attributes[0].limiteSuperior;
        var beca: number = 0;
        var prestamo: number = 0;

        try {
          beca = Number(this.beca?.value?.porcentaje.replace('%', ''));
          if (isNaN(beca)) {
            beca = 0;
          }
        } catch (error) {
          beca = 0;
        }

        try {
          prestamo = Number(this.prestamos?.value?.porcentaje.replace('%', ''));
          if (isNaN(prestamo)) {
            prestamo = 0;
          }
        } catch (error) {
          prestamo = 0;
        }

        const sumaPorcentaje = beca + prestamo;

        if (sumaPorcentaje <= this.limiteSuperior) {
          this.calcular();
          this.hasErrorLimiteSuperior = false;
        } else {
          this.periodoSelected()
          this.hasErrorLimiteSuperior = true;
          this.emmiter.resumenEmmiter.emit(null);
          this.emmiter.borrarFormulario.emit();
        }
        
      }, error: (error: Error) => {
        throw new Error(error.message);
      }
    })

  }

  useCaseCalcular(body) {
    this.usecase.calcular(body).subscribe((response: CalcularModel) => {
      this.emmiter.resumenEmmiter.emit({
        calcular: response.data?.attributes,
        area: this.area?.value,
        nivel: this.nivelAcademico?.value,
        periodo: this.periodo?.value,
      });
    });
  }

  get nivelAcademico() {
    return this.formColegiatura.get("nivelAcademico");
  }
  get periodo() {
    return this.formColegiatura.get("periodo");
  }
  get campus() {
    return this.formColegiatura.get("campus");
  }
  get area() {
    return this.formColegiatura.get("area");
  }
  get programa() {
    return this.formColegiatura.get("programa");
  }
  get beca() {
    return this.formColegiatura.get("beca");
  }
  get apoyos() {
    return this.formColegiatura.get("apoyos");
  }
  get prestamos() {
    return this.formColegiatura.get("prestamos");
  }
  get gastosMedicosMayores() {
    return this.formColegiatura.get("gastosMedicosMayores");
  }
}
